import React from 'react';

import DatepickerContainer from '../../../Componant/Forms/FormWidget/DatePicker';

const Datepicker = () => {
  return (
    <div className='page-body'>
      <DatepickerContainer />
    </div>
  );
};

export default Datepicker;
